function mergeLimitsAndExclusions(data) {
  const LIMITS = 'limits'
  const LIMITS_RX = 'limits-rx'
  const LIMITS_APPEND = 'limits-append'

  if (data && data.plan && data.plan.length > 0) {
    data.plan = data.plan.reduce((previous, current) => {
      if (current.descriptionType === LIMITS || current.descriptionType === LIMITS_RX) {
        previous.push({
          descriptionType: current.descriptionType,
          headline: current.headline,
          body: [{ subtitle: current.disclaimer, body: current.body }]
        })
      } else if (
        current.descriptionType === LIMITS_APPEND &&
        previous.length > 0 &&
        (previous[previous.length - 1].descriptionType === LIMITS ||
          previous[previous.length - 1].descriptionType === LIMITS_RX)
      ) {
        previous[previous.length - 1].body.push({
          subtitle: current.headline,
          body: current.body
        })
      } else {
        previous.push(current)
      }

      return previous
    }, [])
  }

  return data
}

export default mergeLimitsAndExclusions
